import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication, EventType, type AuthenticationResult } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter } from 'react-router-dom';
import { msalConfig } from './authConfig';
import { AuthProvider } from './contexts/AuthContext';
import { App } from './App';
import './styles/branding.css';
import './styles/main.css';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const result = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(result.account);
  }
});

(async () => {
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();
  const accounts = msalInstance.getAllAccounts();
  const first = accounts[0];
  if (first && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(first);
  }

  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Root element missing');

  createRoot(rootElement).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </MsalProvider>
    </StrictMode>,
  );
})();
